export const searchTypes = {
  SEARCH: "[search] search",
  CLEAR: "[search] clear",
  UPDATE: "[search] update"
}
